import { render, staticRenderFns } from "./AllDispensationSubmissions.vue?vue&type=template&id=d5ef7124&scoped=true&"
import script from "./AllDispensationSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllDispensationSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllDispensationSubmissions.vue?vue&type=style&index=0&id=d5ef7124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ef7124",
  null
  
)

export default component.exports